import React from "react";

const FirstSections = () => {
  return (
    <div data-aos="fade-down-right" className="mt-10 shadow-md shadow-slate-400 p-5">
      <h1 className="text-2xl text-primary font-semibold underline text-left">
        Overview of The Problem:{" "}
      </h1>
      <p className="mt-2 text-lg font-medium text-slate-600 text-left">
        The fact that our designer goods do not represent wealth for positive
        utility is having more negative damage to society than we can fathom.
        This article is going to help detail why, and detail our solution in
        progress. <br />
        <br /> As individuals, once we cover our basic needs, status becomes an
        intrinsic motivator in the rest of our actions. Status comes in many
        forms. The healthiest / most enlightened cultures put the highest status
        in rewarding positive sum behavior. In global culture, luxury goods like
        a Gucci bag/belt have become widespread as top status symbols,
        reflecting vapid use of money as the highest form of status. It has
        become such common Christmas list item for broke young teenagers that
        the{" "}
        <a
          className="underline link-primary"
          href="https://www.businesstoday.in/visualstories/technology/who-is-bernard-arnault-meet-worlds-richest-person-alive-who-once-again-beat-elon-musk-24896-03-03-2023"
        >
          richest man on the planet
        </a>{" "}
        at the time of this writing got his riches from selling these overpriced
        goods representing nothing more than the ability to waste money.
        Collectively this misrepresentation of true status (service to others)
        is attributing more damage to building a healthy positive culture than
        we can imagine. <br />
        <br /> Social media, our emergent global cultural production system,
        could be used collectively to unify humanity around bettering ourselves
        and others. Instead it is used to further extract youth through a false
        form of{" "}
        <a
          className="underline link-primary"
          href="https://www.eugenewei.com/blog/2019/2/19/status-as-a-service"
        >
          status as a service
        </a>
        . Imagine a world where this wasteful spending was considered
        cancelable. One where we collectively take accountability for the
        capability to money to the positive growth of us as a species. Imagine a
        world where the designer things we wore showed off spending a lot of
        money to make a lot of positive impact. If the world you imagined only
        went as far as to redistribute the wealth of designer wear, try
        imagining the deeper cultural effects this new alignment would have.
      </p>

      <p className="mt-10 text-xl border-l-4 border-primary font-medium text-slate-600 text-left pl-5 font-sans hover:font-serif">
        “Over the past hundred years we have increase the global GDP sevenfold,
        yet wealth inequality continues to skyrocket and luxury spending grows
        rapidly. In order to change the failure of redistribution of wealth at
        scale, we must effectively influence culture and help redefine what
        “status” is in the modern age. This will ultimately change the flow of
        money in society as the new age of status being helping the world,
        becomes more prominent. We have failed at building a society which
        healthily distributes wealth/power. Given society is a collective
        project we are responsible for, we think this stems from the culture not
        supporting doing good as the highest form of status. We have more than
        enough resources, but many people without access to them, and a culture
        that motivates and glorifies overspending on vanity luxury goods.” -
       <a className="underline link-primary" href="https://jackjay.io/">Jack Jay</a> 
      </p>
    </div>
  );
};

export default FirstSections;
